"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailContentType = exports.EmailTransportType = void 0;
var EmailTransportType;
(function (EmailTransportType) {
    EmailTransportType["EWS"] = "ews";
    EmailTransportType["OUTLOOK365"] = "o365";
})(EmailTransportType = exports.EmailTransportType || (exports.EmailTransportType = {}));
var EmailContentType;
(function (EmailContentType) {
    EmailContentType["HTML"] = "html";
    EmailContentType["TEXT"] = "text";
})(EmailContentType = exports.EmailContentType || (exports.EmailContentType = {}));
//# sourceMappingURL=email.js.map